import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import SetsAndItems from 'src/common/organisms/setsanditems/SetsAndItems';
import {
    OrderDetailMainContainer,
    SetsItemsCotainer,
} from 'src/pages/orders/components/orderDetails/orderDetailTab/OrderDetailTab.styled';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const SetsOrderDetail = ({
    toggleCard,
    sets,
    isSetAvailabilityPending,
    handleSetItemClick,
    ordersList,
}) => {
    const [setsList, setSetsList] = useState([]);
    const { t } = useTranslation();

    const { orderDetails } = useSelector((state) => state.orderSummaryReducer);
    const { setAvailabilityPending } = useSelector(
        (state) => state.orderSummaryReducer
    );

    useEffectWithErrorLogging(() => {
        if (!isSetAvailabilityPending) {
            if (orderDetails?.length > 0) {
                const setDetails = orderDetails?.filter(
                    (order) => order.isSet === true
                );
                setSetsList(setDetails);
            }
        } else {
            if (setAvailabilityPending?.length > 0) {
                setSetsList(setAvailabilityPending);
            }
        }
    }, [orderDetails, setAvailabilityPending]);

    const HeaderTitle = `${t('ConsignmentAdd.shipping.sets')} (${
        setsList?.length ? setsList?.filter(
            (d) =>
                d?.status !==
                    'キャンセル' &&
                d?.status?.toLowerCase() !==
                    'cancel'
        )?.length : 0
    })`;

    return (
        <>
            <CollapsableCard
                id="orders-setsOrderDetail-setsOrderDetail-sets"
                title={HeaderTitle}
                onClick={() => toggleCard('sets', !sets)}
                isExpanded={sets}
                padding={'1rem'}
                cursor={'pointer'}
            >
                {sets ? (
                    <>
                        <OrderDetailMainContainer>
                            {setsList?.length > 0 ? (
                                <>
                                    {setsList.map((setDetails) => {
                                        const setsDetails = {
                                            ...setDetails,
                                            id: setDetails.cfn,
                                            quantity: isSetAvailabilityPending
                                                ? setDetails.orderedQty
                                                : setDetails.quantity,
                                            uom: isSetAvailabilityPending
                                                ? t('common.setLabel')
                                                : setDetails.isSet
                                                ? t(
                                                      'orders.shipTrackLabels.setLabel'
                                                  )
                                                : setDetails?.uom
                                                ? setDetails?.uom
                                                : t(
                                                      'orders.shipTrackLabels.eaLabel'
                                                  ),
                                            orderType:
                                                ordersList &&
                                                ordersList?.currentOrderType
                                                    ? ordersList?.currentOrderType
                                                    : null,
                                        };
                                        return (
                                            <SetsItemsCotainer
                                                key={setDetails.cfn}
                                            >
                                                <SetsAndItems
                                                    setOrItemDetails={
                                                        setsDetails
                                                    }
                                                    isQuantity
                                                    boxShadow={
                                                        '0px 0px 6px #00000029'
                                                    }
                                                    addfullBorder={
                                                        '1px solid #74DED6'
                                                    }
                                                    showStatus={
                                                        setDetails?.status
                                                            ? true
                                                            : false
                                                    }
                                                    showHome={
                                                        setDetails?.home
                                                            ? true
                                                            : false
                                                    }
                                                    marginOnMediumDevice={
                                                        '0 0 15px 0'
                                                    }
                                                    marginOnLargeDevice={
                                                        '0 0 15px 0'
                                                    }
                                                    margin={'0px 0px 10px 0px'}
                                                    setNameColor={'#1010EB'}
                                                    setNameFontSizeDesktop={
                                                        '15px'
                                                    }
                                                    setNameFontSizeMobile={
                                                        '15px'
                                                    }
                                                    onSetItemClick={
                                                        handleSetItemClick
                                                    }
                                                    setDescriptionMinWidth={
                                                        '0px'
                                                    }
                                                    clickable={true}
                                                    isSet={setsDetails?.isSet}
                                                    isOrderDetail
                                                />
                                            </SetsItemsCotainer>
                                        );
                                    })}
                                </>
                            ) : null}
                        </OrderDetailMainContainer>
                    </>
                ) : null}
            </CollapsableCard>
        </>
    );
};

export default SetsOrderDetail;
